module.exports = __webpack_public_path__ + "img/diagram.659e135d.jpg";